import React, { useState } from "react";
import { Box, HStack, Text } from "@chakra-ui/react";
import ReactPlayer from "react-player";
import { useFreeTrialToast } from "src/store/hooks/useFreeTrialToast";
import { useIntl } from "react-intl";
import { useFreeTrial } from "src/free-trial/helpers";
import { FaCrown, FaPlay } from "react-icons/fa";
const Videos = ({
  videos,
  center = true,
  responsive = false,
  locked = false,
}: {
  videos: {
    url: string;
    title: string;
  }[];
  center?: boolean;
  responsive?: boolean;
  locked?: boolean;
}) => {
  const [pause, setPause] = useState<Array<boolean>>(videos.map(() => false));

  const { showFreeTrialToast } = useFreeTrialToast();
  const { formatMessage } = useIntl();

  const { isTrialUser } = useFreeTrial(0);

  return (
    <HStack
      padding="30px 0"
      width="100%"
      display="flex"
      flexWrap="wrap"
      justifyContent={center ? "center" : "flex-start"}
    >
      {videos?.map((video, index) => (
        <Box
          width={
            responsive ? ["250px", "300px", "350px", "400px", "450px"] : "250px"
          }
          height={responsive ? ["150px", "200px", "250px"] : "150px"}
          key={index}
          margin="45px 10px !important"
          position="relative"
          onClick={() => {
            showFreeTrialToast({
              message: formatMessage({
                id: "subscription.subscribeIsRequired",
              }),
              route: "/subscription",
              routeLabel: formatMessage({
                id: "subscription.subscribeNow",
              }),
              autoClose: true,
            });
          }}
        >
          {!isTrialUser ? (
            <ReactPlayer
              preload="none"
              key={index}
              className="react-player fixed-bottom"
              url={video.url}
              controls={!locked}
              width="100%"
              height="100%"
              style={{ minWidth: "100%", minHeight: "100%" }}
              playing={pause[index]}
              onPlay={() => {
                const newArr = pause.map(() => false);
                newArr[index] = !newArr[index];
                setPause(newArr);
              }}
              playsInline
            />
          ) : (
            <Box width="100%" height="100%" backgroundColor={"black"} />
          )}
          {isTrialUser && (
            <Box
              width="100px"
              height={"100px"}
              position={"absolute"}
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              zIndex={2}
            >
              <FaPlay
                size={60}
                color="white"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              />
            </Box>
          )}
          {isTrialUser && (
            <Box
              position="absolute"
              top={2}
              right={2}
              bgColor="#ffd700"
              zIndex={2}
              padding="5px"
              borderRadius="50%"
            >
              <FaCrown size={40} color="black" />
            </Box>
          )}
          <Text
            position="relative"
            textAlign="center"
            fontWeight="bold"
            marginTop="3"
            fontSize="20px"
          >
            {video.title}
          </Text>
        </Box>
      ))}
    </HStack>
  );
};

export default Videos;
